import { useState } from "react";
import Cats from "./../../Components/Cats";
import Posts from "./../../Components/Posts";
import Answers from "./../../Components/Answers";
import Curriculums from "./../../Components/Curriculums";
import Tests from "./../../Components/Tests";
import Users from "./../../Components/Users";
import Ads from "./../../Components/Ads";
import Passes from "./../../Components/Passwords";
import { useDispatch } from "react-redux";
import { removePassword } from "./../../../../REDUX/Slices/users.Slice";
import "./index.scss";

export default function ADM() {
  const [selected, setSelected] = useState(null);
  const dispatch = useDispatch();

  const goBack = () => setSelected(null);

  const contentComponents = {
    posts: <Posts goBack={goBack} />,
    cats: <Cats goBack={goBack} />,
    answers: <Answers goBack={goBack} />,
    curriculums: <Curriculums goBack={goBack} />,
    tests: <Tests goBack={goBack} />,
    ads: <Ads goBack={goBack} />,
    users: <Users goBack={goBack} />,
    passes: <Passes goBack={goBack} />,
  };

  if (selected) return contentComponents[selected];

  return (
    <>
      {selected ? (
        contentComponents[selected]
      ) : (
        <div className="adm">
          <div className="container">
            <header>
              <h2>لوحة تحكم المدير</h2>
              <p>اهلا بك من جديد..</p>
            </header>
            <div className="row">
              <div className="navigator">
                <div className="nav-box" onClick={() => setSelected("posts")}>
                  <span>
                    <i className="fa-duotone fa-typewriter"></i>
                  </span>
                  <p>التدوينات</p>
                </div>
                <div
                  className="nav-box"
                  onClick={() => setSelected("curriculums")}
                >
                  <span>
                    <i className="fa-duotone fa-graduation-cap"></i>
                  </span>
                  <p>المناهج</p>
                </div>
                <div className="nav-box" onClick={() => setSelected("tests")}>
                  <span>
                    <i className="fa-duotone fa-pen-field"></i>
                  </span>
                  <p>الاختبارات</p>
                </div>
                <div className="nav-box" onClick={() => setSelected("answers")}>
                  <span>
                    <i className="fa-duotone fa-badge-check"></i>
                  </span>
                  <p>الاجابات</p>
                </div>
                <div className="nav-box" onClick={() => setSelected("users")}>
                  <span>
                    <i className="fa-duotone fa-user-group"></i>
                  </span>
                  <p>المستخدمين</p>
                </div>
                <div className="nav-box" onClick={() => setSelected("cats")}>
                  <span>
                    <i className="fa-duotone fa-folder"></i>
                  </span>
                  <p>التخصصات</p>
                </div>
                <div className="nav-box" onClick={() => setSelected("passes")}>
                  <span>
                    <i className="fa-duotone fa-lock"></i>
                  </span>
                  <p>كلمات المرور</p>
                </div>
                <div className="nav-box" onClick={() => setSelected("ads")}>
                  <span>
                    <i className="fa-duotone fa-sack-dollar"></i>
                  </span>
                  <p>الاعلانات</p>
                </div>
              </div>
            </div>
            <div className="btn">
              <button onClick={() => dispatch(removePassword())}>خروج</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
